/* eslint-disable import/prefer-default-export */
import { isProd } from 'Utils/env/env';
import React, { useEffect } from 'react';

export const DEVTOOLS_KEY = 'devtools';

export const withDevTools = (Component) => {
  function ComponentWithDevtools({ ...props }) {
    useEffect(() => {
      if (!isProd()) {
        const query = new URLSearchParams(window.location.search);
        const devToolsQueryParam = query.get(DEVTOOLS_KEY);

        if (devToolsQueryParam === 'true') {
          localStorage.setItem('DEVTOOLS', 'true');
          query.delete(DEVTOOLS_KEY);
          window.location.assign(`${window.location.pathname}?${query}`);
        }
      }
    }, []);

    return (
      <Component {...props} />
    );
  }
  return ComponentWithDevtools;
};
